import { render, staticRenderFns } from "./SalaryForm.vue?vue&type=template&id=3b2aa2e0&scoped=true&"
import script from "./SalaryForm.vue?vue&type=script&lang=js&"
export * from "./SalaryForm.vue?vue&type=script&lang=js&"
import style0 from "./SalaryForm.vue?vue&type=style&index=0&id=3b2aa2e0&prod&scoped=true&lang=css&"
import style1 from "./SalaryForm.vue?vue&type=style&index=1&id=3b2aa2e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2aa2e0",
  null
  
)

export default component.exports